var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGenerate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.239,2.071c17.373-1.36,29.423,17.186,21.026,32.563-8.306,15.21-30.377,15.137-38.606-.112C-2.894,20.527,6.481,3.304,22.239,2.071ZM20.384,27.812v-5.76l9.971-9.968c.17-.146.224-.228.086-.441-.393-.604-4.472-1.494-5.325-1.549-14.107-.917-20.659,17.128-9.254,25.252,11.976,8.53,26.865-4.653,20.67-17.679l-10.221,10.145h-5.928ZM23.132,24.89l1.986-.163,12.616-12.648-1.801-1.802-12.638,12.626-.163,1.988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGenerate);
export default __webpack_public_path__ + "static/media/icon-generate.375993fb6a466cf4042cc420407b5949.svg";
export { ForwardRef as ReactComponent };